import { getJti } from '@util'
import { LEAFLET_LINK, SOURCE_HLJ, WCD_ROUTE_EDIT } from './constant'

/**
 * 聚客宝活动
 */
export const isJuKeActivity = finderActivityId => {
  return finderActivityId > 0
}

export const getWcdPath = (route, id, extra) => {
  let base = id
    ? `${LEAFLET_LINK}/${route}/${id}?jti=${getJti()}&source=${SOURCE_HLJ}`
    : `${LEAFLET_LINK}/${route}?jti=${getJti()}&source=${SOURCE_HLJ}`

  if (extra) {
    base = `${base}&${extra}`
  }

  return base
}

/**
 * 跳转微传单工程
 * @param {*} route 微传单路由
 * @param {*} id 微传单id
 * @param {*} extra url额外携带参数
 */
export const goWcdPath = (route, id, extra) => {
  window.open(getWcdPath(route, id, extra))
}

export const goNewWcd = id => {
  let base = `${LEAFLET_LINK}/${WCD_ROUTE_EDIT}`
  let link = ''

  if (id) {
    link = `${base}/${id}/new?jti=${getJti()}&source=${SOURCE_HLJ}`
  } else {
    link = `${base}?jti=${getJti()}&source=${SOURCE_HLJ}`
  }

  window.open(link)
}

export const goCopyWcd = id => {
  const link = `${LEAFLET_LINK}/${WCD_ROUTE_EDIT}/${id}/copy?jti=${getJti()}&source=${SOURCE_HLJ}`
  window.open(link)
}
